/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CreateOrUpdateMerchantUnitOvertimeRulesetRequest} from '@cash-web/protos/squareup/timecards/service.pb'
import {CreateOrUpdateMerchantUnitOvertimeRulesetResponse} from '@cash-web/protos/squareup/timecards/service.pb'


export const createOrUpdateMerchantUnitOvertimeRuleset = (request: CreateOrUpdateMerchantUnitOvertimeRulesetRequest, options?: CashRequestOptions) => post<CreateOrUpdateMerchantUnitOvertimeRulesetRequest, CreateOrUpdateMerchantUnitOvertimeRulesetResponse>("/proxy/services/squareup.timecards.TimeCalculationService/CreateOrUpdateMerchantUnitOvertimeRuleset", request, {...options, rejectOnError: true })